import axios from './axiosInstance';
import { API_ROUTES } from '../constants/apiRoutes';

export const loginAdmin = async (payload) => {
  try {
    const res = await axios.post(API_ROUTES.LOGIN, payload);
    return res;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
};

export const verifyLoginAdmin = async (payload) => {
  console.log({ payload })
  try {
    const res = await axios.post(API_ROUTES.VERIY_LOGIN, payload);
    return res;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
};
